import React, { useEffect, useMemo, useState } from "react";
import { Resizable } from "react-resizable";
import "./index.css";

export const ResizableTitle = ({ onResize, width, minWidth, ...restProps }) => {
  if (!width || !onResize) return <th {...restProps} />;
  return (
    <Resizable
      width={width}
      height={0}
      minConstraints={[minWidth, 0]}
      handle={
        <span
          className="resizable-column-handle"
          onClick={(e) => e.stopPropagation()}
        />
      }
      onResize={onResize}
      draggableOpts={{ enableUserSelectHack: false }}
    >
      <th
        {...restProps}
        className={`${restProps.className ?? ""} resizable-column`}
      />
    </Resizable>
  );
};

const defaultSkip = (col) => col.dataIndex === "action";

export const useResizableColumns = (
  columns,
  { minWidth = 40, skip = defaultSkip, resetKey } = {},
) => {
  const [widths, setWidths] = useState({});

  useEffect(() => {
    setWidths({});
  }, [resetKey]);

  const resizableColumns = columns.map((col, index) => {
    if (skip(col) || typeof col.width !== "number") return col;
    const id = col.dataIndex ?? col.key ?? index;
    return {
      ...col,
      width: widths[id] ?? col.width,
      onHeaderCell: (column) => ({
        ...col.onHeaderCell?.(column),
        width: column.width,
        minWidth,
        onResize: (_, { size }) =>
          setWidths((prev) => ({ ...prev, [id]: size.width })),
      }),
    };
  });

  const components = useMemo(() => ({ header: { cell: ResizableTitle } }), []);

  return { columns: resizableColumns, components };
};
